<template>
  <div class="footer" ref="footer">
    <div class="content-container">
      <div class="follow-section">
        <div class="section-title">Follow Us</div>
        <div class="follow-list">
          <a
            href="https://www.youtube.com/@yourslinkuk"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="访问 Yours Link 的 YouTube 频道"
          >
            <ProgressiveImage img-class="icon" :src="youtube_svg" alt="YouTube 图标" />
          </a>
          <a
            href="https://www.instagram.com/@yourslinkuk/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="访问 Yours Link 的 Instagram 页面"
          >
            <ProgressiveImage img-class="icon" :src="ins_svg" alt="Instagram 图标" />
          </a>
        </div>
      </div>
      <div class="company-section">
        <section>
          <div class="section-title">UK Address</div>
          <div class="section-content">
            <div class="office-item" v-for="office in footerOffice" :key="office.title">
              <div class="office-title">
                <ProgressiveImage container-class="icon-wrapper" img-class="icon" :src="city_svg" />
                <span>{{ office.title }}</span>
              </div>
              <div class="flex">
                <ProgressiveImage
                  container-class="icon-wrapper"
                  img-class="icon"
                  :src="address_svg"
                />
                <span>{{ office.address }}</span>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="section-title">CONTACT US</div>
          <div class="section-content">
            <div class="office-item" v-for="contact in footerContact" :key="contact.title">
              <div class="office-title">{{ contact.title }}</div>
              <div>
                <ProgressiveImage img-class="icon" :src="mail_svg" />
                {{ contact.email }}
              </div>
            </div>
          </div>
        </section>
        <section class="cooperative">
          <div class="section-title">Cooperative Institution</div>
          <div class="section-content">
            <!-- 该图片组v-for footerLogo,是动态图片,无法使用 progressiveImage 组件 -->
            <img
              v-for="(item, index) in footerLogo"
              :key="index"
              @click="openPage(item.link)"
              :src="item.src"
              :alt="item.name ? `${item.name} - 合作机构` : '合作机构logo'"
              width="48"
              height="48"
            />
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import * as allIcons from '@/assets/images/icon';
export default {
  data() {
    return {
      youtube_svg: allIcons.youtube,
      ins_svg: allIcons.ins,
      city_svg: allIcons.city,
      address_svg: allIcons.address,
      mail_svg: allIcons.mail,
    };
  },
  computed: {
    ...mapGetters(['footerOffice', 'footerContact', 'footerLogo']),
  },
  methods: {
    openPage(link) {
      window.open(link);
    },
  },
};
</script>
<style scoped lang="scss">
.footer {
  padding: 2.4rem 0;
  width: 100%;
  height: auto;
  background: #16347d;
  color: #ffffff;
}

::v-deep .icon-wrapper {
  flex-shrink: 0;
}
::v-deep .icon {
  margin-right: 0.8rem;
  width: 1rem;
  height: 1rem;
}

.follow-section {
  display: flex;
  align-items: flex-start;
  margin-bottom: 2.4rem;
  padding-top: 0.2rem;
  border-bottom: 1px solid #979797;

  .section-title {
    margin-right: 2rem;
  }

  ::v-deep .icon {
    width: 1.8rem;
    height: 1.8rem;
    // padding-bottom: 2.4rem;
  }

  ::v-deep .icon:first-child {
    width: 2.4rem;
  }
}

.section-title {
  padding-bottom: 2.4rem;
  font-size: 1.2rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 1.4rem;
}

.section-title::after {
  content: '';
  display: block;
  margin-top: 0.5rem;
  width: 50px;
  height: 4px;
  background: #f7d038;
  border-radius: 4px;
}

.company-section {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 2rem;
}

.office-item {
  margin-bottom: 1.2rem;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #ffffff;
  line-height: 1.3rem;

  div {
    margin-bottom: 1.4rem;
  }
  .office-title {
    font-weight: 600;
    margin-bottom: 0.6rem;
  }
}

section.cooperative {
  cursor: pointer;

  img {
    height: 3rem;
    width: auto;
    margin: 0 1rem 1rem 0;
  }
}

@media only screen and (max-width: 1024px) {
  .content-container {
    padding: 0 2rem;
  }

  .company-section {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
}
</style>
